<div class="mb-3">

    <!-- <div class="alert alert-warning">
        <div>numItems$ => {{numItems$ | async}}</div>
        <div>schemaHasConfirmIfNoItems$ => {{schemaHasConfirmIfNoItems$ | async}}</div>
        <div>schemaConfirmIfNoItemsMessage$ => {{schemaConfirmIfNoItemsMessage$ | async}}</div>
    </div> -->

    <ng-container *ngIf="isSummaryMode$ | async; else DetailMode">
        <a (click)="lgvFormSvc.navigateToParentNode()"><fa-icon icon="arrow-left"></fa-icon> Return</a>
        <lgv-section-title-navigation [title]="lgvFormSvc.pageTitle$ | async"></lgv-section-title-navigation>

        <ng-template #NoData>
            <div *ngIf="props?.noItemsMessage; else NoMsg">{{props?.noItemsMessage}}</div>

            <ng-template #NoMsg>
                There are currently no {{props?.label}} items. Click "{{props?.addText}}" to add some...
            </ng-template>

            <ng-container *ngIf="!(numItems$ | async) && (schemaHasConfirmIfNoItems$ | async) && (schemaConfirmIfNoItemsMessage$ | async)">
                <div class="Vert-15"></div>
                <div><mat-checkbox (change)="onConfirmChanged($event)" [(ngModel)]="confirmedNoItemsForForm">{{schemaConfirmIfNoItemsMessage$ | async}}</mat-checkbox></div>
                <div class="Vert-15"></div>
            </ng-container>

        </ng-template>

        <ng-container *ngIf="model && model.length > 0; else NoData">
            <div *ngFor="let arrayObj of field.fieldGroup; let i = index" class="row align-items-baseline alert alert-loan-app">

                <ng-container *ngIf="lgvFormSvc.observeChangeSummaryForLevel$(lgvFormSvc.curLevel1$.value, -1, false, i) | async as summary">
                    <div class="arrayItemHeader">
                        <div class="float-start">
                            <div class="Vert-5"></div>
                            <b>{{arrayObj?.props?.label}} {{+arrayObj.key +1}}</b>
                        </div>
                        <div class="float-end"><button class="btn white" (click)="onEditSection(i)" [disabled]="lgvFormSvc.isReadOnlyMode">{{lgvFormSvc.editButtonLabelFromSummary(summary)}}</button></div>
                        <div class="float-end"><button class="btn white" (click)="onConfirmRemoveArrayObject(i, arrayObj)"><fa-icon icon="trash"></fa-icon></button></div>
                    </div>

                    <div>
                        <lgv-section-summary [summary]="summary" [level1Param]="lgvFormSvc.curLevel1$.value" [level2Param]="-1" [sectionLabel]="" [showHeaderRow]="false"></lgv-section-summary>
                    </div>
                </ng-container>

            </div>
        </ng-container>

        <div style="margin:30px 0;" *ngIf="!confirmedNoItemsForForm">
            <button class="btn btn-secondary white" type="button" (click)="add()">{{ props['addText'] }}</button>
        </div>

        <div>
            <a (click)="lgvFormSvc.navigateToParentNode()">Back</a>
            <div class="float-end">
                <button *ngIf="lgvFormSvc.isPreApplicationMode" style="margin-left:20px;" class="btn btn-primary" (click)="lgvFormSvc.navigateToNextSectionSummary()">Next</button>
                <button *ngIf="!lgvFormSvc.isPreApplicationMode" style="margin-left:20px;" class="btn btn-primary" (click)="lgvFormSvc.saveForm(); lgvFormSvc.returnHome()">Save</button>
            </div>
        </div>

    </ng-container>

    <ng-template #DetailMode>
        <!-- <div class="alert alert-warning">Repeating Section Summary - Detail Mode</div> -->
        <a (click)="onEditSection(-1)"><fa-icon icon="arrow-left"></fa-icon> Return to {{props?.label}}</a>
        <h3>{{field?.fieldArray?.props?.label}} {{(selectedIndex$ | async) +1}}</h3>
        
        <form [formGroup]="form" (ngSubmit)="submit()" class="form-gen" (change)="onFormChange($event)">
            <formly-field class="col" [field]="field.fieldGroup[selectedIndex$ | async]" [options]="lgvFormSvc.formlyOptions$ | async"></formly-field>
        </form>

        <div class="Vert-15"></div>
        <div>
            <a (click)="onEditSection(-1)">Back</a>                                
            <div class="float-end">
                <button *ngIf="lgvFormSvc.isPreApplicationMode" class="btn btn-primary" (click)="onEditSection(-1)">Next</button>
                <button *ngIf="!lgvFormSvc.isPreApplicationMode" class="btn btn-primary" (click)="lgvFormSvc.saveForm(); lgvFormSvc.returnHome()">Save</button>
            </div>
        </div>
</ng-template>



</div>